import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { User, Phone, MapPin, ExternalLink } from 'lucide-react';

export const GeneralInfoSection = ({ intervention, isNew, onChange }) => (
  <div className="form-section pl-8">
    <h3 className="text-lg font-semibold uppercase mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
      Dati Generali
    </h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="form-label">Numero Intervento</label>
        <Input
          value={intervention.numero_intervento}
          onChange={(e) => onChange('numero_intervento', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="1805"
          disabled={!isNew}
          data-testid="input-numero-intervento"
        />
      </div>
      <div>
        <label className="form-label">Tipo Intervento</label>
        <Input
          value={intervention.tipo_intervento}
          onChange={(e) => onChange('tipo_intervento', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="Incendio normale (generico)"
          disabled={!isNew}
          data-testid="input-tipo-intervento"
        />
      </div>
      <div>
        <label className="form-label flex items-center gap-2">
          <User className="w-4 h-4 text-[#71717A]" />
          Capo Partenza
        </label>
        <Input
          value={intervention.capo_partenza}
          onChange={(e) => onChange('capo_partenza', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="BATTISTINI CHRISTIAN"
          disabled={!isNew}
          data-testid="input-capo-partenza"
        />
      </div>
      <div>
        <label className="form-label">Richiedente</label>
        <Input
          value={intervention.richiedente}
          onChange={(e) => onChange('richiedente', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="MARRO SARA"
          disabled={!isNew}
          data-testid="input-richiedente"
        />
      </div>
      <div>
        <label className="form-label flex items-center gap-2">
          <Phone className="w-4 h-4 text-[#71717A]" />
          Telefono
        </label>
        <Input
          value={intervention.telefono}
          onChange={(e) => onChange('telefono', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="3349309473"
          disabled={!isNew}
          data-testid="input-telefono"
        />
      </div>
      <div>
        <label className="form-label flex items-center gap-2">
          <MapPin className="w-4 h-4 text-[#71717A]" />
          Indirizzo
        </label>
        <Input
          value={intervention.indirizzo}
          onChange={(e) => onChange('indirizzo', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="VIA NARSETE Forlì"
          disabled={!isNew}
          data-testid="input-indirizzo"
        />
      </div>
      {intervention.coordinate_maps && (
        <div className="md:col-span-2">
          <a
            href={intervention.coordinate_maps}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#E3000F] hover:underline text-sm"
          >
            <ExternalLink className="w-4 h-4" />
            Apri in Google Maps
          </a>
        </div>
      )}
      <div className="md:col-span-2">
        <label className="form-label">Note</label>
        <Textarea
          value={intervention.note}
          onChange={(e) => onChange('note', e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white min-h-[80px]"
          placeholder="Note aggiuntive..."
          disabled={!isNew}
          data-testid="input-note"
        />
      </div>
    </div>
  </div>
);
